import { Component, forwardRef, HostBinding, Inject, Input, OnInit } from '@angular/core';
import { AccountConfigService } from '../../../../services/account-config/account-config.service';
import { AuthService } from '../../../../../auth/services/auth/auth.service';
import { ApprenantService } from '../../../../services/apprenant/apprenant.service';

@Component({
  selector: 'ags-formation-apprenant',
  templateUrl: './formation-apprenant.component.html',
  styleUrls: ['./formation-apprenant.component.scss']
})
export class FormationApprenantComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  @Input('idFormation')
  set _idFormation(value: number) {
    this.idFormation = value;
  }
  constructor(
    @Inject(forwardRef(() => AuthService)) private authService: AuthService,
    @Inject(forwardRef(() => AccountConfigService)) private accountConfigService: AccountConfigService,
    private apprenantService: ApprenantService
  ) {}
  public listApprenant;
  public idFormation: number;

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    if (this.idFormation) {
      this.listApprenant = this.apprenantService.getApprenantBySession(this.idFormation);
    }
  }
}
